// src/components/popups/TopUpErrorDrawer.js
import React from 'react';
import './TopUpErrorDrawer.css';

const TopUpErrorDrawer = ({ onClose, message }) => {
  return (
    <div className="topup-error-drawer">
      <div className="topup-error-content">
        <p className="error-title">Top up failed</p>
        <p className="error-message">
          {message || 'Unknown error. Please try again.'}
        </p>
        <button className="close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default TopUpErrorDrawer;
